<template>
  <div style="margin-top:5px;">
    <Button type="primary" style="margin:5px 0;" @click="reviewFileModal=true">上传新文件</Button>
    <Table :columns="columns" :data="fileList" height="400"></Table>
    <Modal title="评审文件上传" v-model="reviewFileModal" :mask-closable="false" width="800" @on-visible-change="uploadVisibleChange">
      <div>
        <Form :label-width="100">
          <FormItem label="评审文件类型">
            <Select v-model="reviewFileType" style="width:200px" @on-change="fileTypeChange">
              <Option v-for="type in reviewFileTypes" :value="type.title">{{type.title}}</Option>
            </Select>
          </FormItem>
          <FormItem label="文件说明">
            <CheckboxGroup v-model="reviewFileExplain">
              <template v-for="explain in fileExplains">
                <Checkbox :label="explain.title">{{explain.title}}</Checkbox>
              </template>
            </CheckboxGroup>
          </FormItem>
        </Form>
      </div>
      <div style="color:#ed3f14">请先选择评审文件类型和文件说明再进行上传操作</div>
      <Upload type="drag" action="/" :before-upload="beforeUpload">
        <div style="padding: 20px 0">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
          <p>拖拽上传，暂只支持单选文件</p>
        </div>
      </Upload>
      <div style="margin-top:5px">
        <div v-for="uploadFile in uploadedList" class="upload-file-item">
          <span>{{uploadFile.fileName}}</span>
          <span v-if="uploadFile.success" class="upload-success">上传成功</span>
          <span v-else class="upload-fail">上传失败</span>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import localFile from '@/lib/localFile'

export default {
  props: {
    projectData: {
      type: Object
    }
  },
  data() {
    return {
      columns: [
        {
          title: '文件名称',
          key: 'fileName'
        },
        {
          title: '文件类别',
          key: 'fileTypeName',
          width: 150
        },
        {
          title: '上传文件说明',
          key: 'reviewFileName',
          width: 300,
        },
        {
          title: '上传人员',
          key: 'uploadPerson',
          width: 100
        },
        {
          title: '上传时间',
          width: 100,
          render: (h, params) => {
            // let time = new Date(params.row.uploadTime)
            // time = time.toLocaleString().replace(/\//g, '-')
            // return h('span', time)
            if (params.row.uploadTime) {
              return h('span', params.row.uploadTime.split('.')[0].replace('T', ' '))
            }
            return ''
          }
        },
        {
          title: '操作',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除文件',
                      content: `<div>确定删除此文件：${params.row.fileName}<span style="color:#ed3f14">（此操作不可撤回，请谨慎）</span></div>`,
                      onOk: async () => {
                        this.$Spin.show()
                        try {
                          // let formData = new FormData()
                          // formData.append('id', params.row.id)
                          // formData.append('name', this.username)
                          let rep = await ajax.delete(requestUrls.clfile.delFile, { params: { id: params.row.id } })
                          this.$Spin.hide()
                          if (rep.data.success) {
                            this.$Message.success('删除成功')
                            this.getReviewFile()
                          } else {
                            this.$Message.error('删除失败')
                          }
                        } catch (err) {
                          this.$Spin.hide()
                          this.$Message.error('删除失败')
                          console.error(err)
                        }
                      }
                    })
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      fileList: [],
      reviewFileModal: false,
      reviewFileTypes: [
        { title: '竞争性谈判' },
        { title: '竞争性磋商' },
        { title: '单一来源' },
        { title: '询价' },
        { title: '公开招标和邀请招标' },
      ],
      reviewFileType: '竞争性谈判',
      reviewFileExplains: {
        tp: [
          { title: '采购方' },
          { title: '监督方代表签到表' },
          { title: '谈判小组签到表' },
          { title: '谈判小组成员承诺书' },
          { title: '政府采购监督员承诺书' },
          { title: '竞争性谈判顺序确认表' },
          { title: '响应供应商代表签到及谈判响应文件接收表' },
          { title: '响应供应商代表签到及谈判响应文件' },
          { title: '样品/原件接收表' },
          { title: '响应文件撤回表' },
          { title: '响应文件退回表' },
          { title: '响应样品/原件退还表' },
          { title: '资格、符合性评审表' },
          { title: '评委评审意见书' },
          { title: '竞争性谈判会议纪要' },
          { title: '二次(最后)报价表' },
          { title: '最后报价记录表' },
          { title: '专家推荐成交候选供应商意见表' },
          { title: '成交确认函' },
          { title: '谈判文件专家论证意见表' },
          { title: '评委评审意见书' },
        ],
        cs: [
          { title: '采购方' },
          { title: '监督方代表签到表' },
          { title: '评审专家签到表' },
          { title: '磋商小组成员承诺书' },
          { title: '政府采购监督员承诺书' },
          { title: ' 磋商顺序确认表' },
          { title: ' 演示顺序确认表' },
          { title: ' 响应供应商代表签到及响应文件接收表' },
          { title: ' 响应供应商代表签到及响应文件' },
          { title: ' 响应样品/原件接收表' },
          { title: ' 响应文件撤回表' },
          { title: ' 响应文件退回表' },
          { title: ' 响应样品/原件退还表' },
          { title: ' 资格、符合性评审表' },
          { title: ' 评委评审意见书' },
          { title: ' 磋商会议纪要' },
          { title: ' 二次（最后）报价表' },
          { title: ' 最后报价记录表' },
          { title: ' 专家推荐成交候选供应商意见表' },
          { title: ' 成交确认函' },
          { title: '  磋商文件专家论证意见表' },
          { title: ' 评委评审意见书' },
          { title: ' 开标记录表' },
          { title: ' 初审表' },
          { title: ' 价格评分表' },
          { title: ' 技术评分表' },
          { title: ' 商务评分表' },
          { title: ' 评审结果汇总表' },
        ],
        ly: [
          { title: '采购方' },
          { title: '监督方代表签到表' },
          { title: '谈判小组签到表' },
          { title: '谈判小组成员承诺书' },
          { title: '政府采购监督员承诺书' },
          { title: '响应供应商代表签到及谈判响应文件接收表' },
          { title: '响应供应商代表签到及谈判响应文件' },
          { title: '样品/原件接收表' },
          { title: '响应文件撤回表' },
          { title: '响应文件退回表' },
          { title: '响应样品/原件退还表' },
          { title: '资格、符合性评审表' },
          { title: '评委评审意见书' },
          { title: '单一来源谈判会议纪要' },
          { title: '二次(最后)报价表' },
          { title: '最后报价记录表' },
          { title: '专家推荐成交候选供应商意见表' },
          { title: '成交确认函' },
          { title: '谈判文件专家论证意见表' },
          { title: '评委评审意见书' },
        ],
        xj: [
          { title: '采购方' },
          { title: '监督方代表签到表' },
          { title: '谈判小组签到表' },
          { title: '谈判小组成员承诺书' },
          { title: '政府采购监督员承诺书' },
          { title: '响应供应商代表签到及谈判响应文件接收表' },
          { title: '响应供应商代表签到及谈判响应文件' },
          { title: '样品/原件接收表' },
          { title: '响应文件撤回表' },
          { title: '响应文件退回表' },
          { title: '响应样品/原件退还表' },
          { title: '资格、符合性评审表' },
          { title: '评委评审意见书' },
          { title: '成交确认函' },
          { title: '询价通知书专家论证意见表' },
          { title: '评委评审意见书' },
        ],
        zb: [
          { title: '开标会议签到表' },
          { title: '评标委员会成员签到表' },
          { title: '政府采购评标委员会成员承诺书' },
          { title: '演示顺序确认表' },
          { title: '投标人代表签到及投标文件接收表' },
          { title: '投标人代表签到及投标文件' },
          { title: '投标样品/原件接收表' },
          { title: '投标文件撤回表' },
          { title: '投标文件退回表' },
          { title: '投标样品/原件退还表' },
          { title: '评标委员会推荐中标候选人意见表' },
          { title: '中标确认函、评标报告' },
          { title: '招标文件专家论证意见表' },
          { title: '评委评审意见书' },
          { title: '政府采购活动回避申请书' },
          { title: '开标记录表' },
          { title: '初审表' },
          { title: '价格评分表' },
          { title: '技术评分表' },
          { title: '商务评分表' },
          { title: '评审结果汇总表' },
        ],
      },
      reviewFileExplain: [],
      uploadedList: [],
    }
  },
  created() {
    this.getReviewFile()
  },
  computed: {
    username() {
      return this.$store.state.session.user.name
    },
    fileExplains() {
      let explainList = []
      switch (this.reviewFileType) {
        case '竞争性谈判':
          explainList = this.reviewFileExplains.tp
          break
        case '竞争性磋商':
          explainList = this.reviewFileExplains.cs
          break
        case '单一来源':
          explainList = this.reviewFileExplains.ly
          break
        case '询价':
          explainList = this.reviewFileExplains.xj
          break
        case '公开招标和邀请招标':
          explainList = this.reviewFileExplains.zb
          break
      }
      return explainList
    }
  },
  methods: {
    async getReviewFile() {
      const fl = 67
      // let rep = await axios.post(`http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpGetFileList?npid=${this.projectData.id}&fl=${fl}`)

      const params = {
        filter: `fileTypeId=="${fl}" and projectId=="${this.projectData.id}"`
      }
      let rep = await ajax.get(requestUrls.clfile.getList, { params })
      this.fileList = rep.data.result
    },
    fileTypeChange() {
      this.reviewFileExplain = []
    },
    beforeUpload(file) {
      if (this.reviewFileExplain.length === 0) {
        this.$Message.error('最少选择一个文件说明')
        return false
      }
      let format = ['jpg', 'jpeg', 'pdf', 'png', 'tif', 'tiff', 'rar', 'zip', 'doc', 'docx', 'xlsx', 'xls']
      let type = file.name.split('.')
      type = type[type.length - 1]
      if (format.indexOf(type) === -1) {
        this.$Message.error('不支持的文件类型')
        return false
      }
      this.fileToUpload(file)
      return false
    },
    async fileToUpload(file) {
      const fl = 67
      // let formData = new FormData()
      // formData.append('fileToUpload', file)
      // formData.append('username', this.username)
      // formData.append('fl', fl)
      // formData.append('fileclass', this.reviewFileType)
      // formData.append('pswjmc', this.reviewFileExplain.join(' '))
      // formData.append('npid', this.projectData.id)
      this.$Spin.show()
      try {
        // let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpUpload', formData)
        // 上传文件
        let fileRep = await localFile.uploadFile(file)

        if (!fileRep) {
          throw 'uploadError'
        }

        // 提交记录
        const params = {
          projectId: this.projectData.id,
          fileName: fileRep.fileName,
          fileGuid: fileRep.serviceGuid,
          fileSuffix: fileRep.extension,
          fileTypeId: fl,
          uploadPerson: this.username,
          fileTypeName: this.reviewFileType,
          reviewFileName: this.reviewFileExplain.join(' ')
        }
        let recordRep = await localFile.createFileRecord(params)

        if (!recordRep) {
          throw 'RecordError'
        }

        this.$Spin.hide()
        
        this.uploadedList.push({
          fileName: file.name,
          success: true
        })
        this.$Message.success('上传成功')
        this.getReviewFile()

      } catch (err) {
        console.error(err)
        this.uploadedList.push({
          fileName: file.name,
          success: false
        })
        this.$Spin.hide()
        this.$Message.error('上传失败')
      }
    },
    uploadVisibleChange(val) {
      if (!val) {
        this.uploadedList = []
      }
    },
  }
}
</script>

<style lang="less" scoped>
.upload-file-item {
  position: relative;
  padding: 2px 5px;
  .upload-success {
    position: absolute;
    right: 10px;
    color: #19be6b;
  }
  .upload-fail {
    position: absolute;
    right: 10px;
    color: #ed3f14;
  }
}
.upload-file-item + .upload-file-item {
  border-top: 1px solid #ddd;
}
</style>
